<template>
    <v-app>
        <v-snackbar
                v-model="snackbar"
                top=true
                color="red"
                timeout=4000
        >
            {{ errorMsg }}
            <v-btn
                    color="white"
                    icon
                    @click="snackbar = false"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-snackbar>
        <v-container class="mt-10">
            <v-row style="background-color: rgba(255, 255, 255, .8);" class="mb-2 text-left">
                <v-col class="d-none d-md-block text-center mt-8" md="2">
                    <v-icon size="100">mdi-rss</v-icon>
                </v-col>
                <v-col cols="12" md="10">
                    <h2>Nouveau ! Vous voyez maintenant les nouvelles missions sur votre page d'accueil</h2>
                    <p class="mt-4">Cliquez dans la barre de menu sur <v-icon>mdi-calendar</v-icon> pour voir les missions que vous avez acceptées en mode calendrier.</p>
                    <p>Cliquez dans la barre de menu sur <v-icon>mdi-alert-decagram</v-icon> pour les nouvelles missions qui n'ont pas encore été acceptées.</p>
                    <p style="color:red" class="mt-4">Nous vous rappelons que la <strong>date affichée</strong> est la date à laquelle le prospect désire être contacté. Essayez de respecter les horaires !</p>
                </v-col>
            </v-row>
            <div v-if="loading">
                <v-row>
                    <v-col>
                        Chargement des rendez-vous en cours.<br>
                        Veuillez patienter
                    </v-col>
                </v-row>
            </div>
            <div v-if="!loading && rdvs.length == 0">
                <v-row>
                    <v-col>
                        <v-alert color="indigo" dark>
                            <h3>Pas de nouveau rendez-vous à prendre en charge.</h3>
                        </v-alert>
                    </v-col>
                </v-row>
            </div>
            <div v-if="!loading && rdvs.length > 0">
                <div v-for="rdv in rdvs" v-bind:key="rdv.id">
                    <v-row v-if="rdv.assignedagentid == '' || rdv.assignedagentid == userId" style="background-color: rgba(255, 255, 255, .6);" class="mb-2">
                        <v-col>
                            <h4 class="text-left">Le {{rdv.computed.date}} à {{rdv.computed.heure}}</h4>
                            <p class="text-left">
                                Contacter {{rdv.name}} par {{rdv.contactmethod}}
                                <br>
                                GSM :
                                <span v-if="rdv.contactmethod == 'WhatsApp'"><a :href="'whatsapp://send?phone=' + rdv.computed.whatsappnumber">{{rdv.gsm}}</a></span>
                                <span v-if="rdv.contactmethod == 'Téléphone'"><a :href="'tel:'+rdv.computed.whatsappnumber">{{rdv.gsm}}</a></span>
                                <span v-if="rdv.contactmethod == 'Skype'">{{rdv.gsm}}</span>
                                <br>
                                Mail : {{rdv.mail}}
                                <span v-if="rdv.contactmethod == 'Skype'">
                                    <br>
                                        Skype : <a :href="'skype:'+rdv.skypeid+'?call'">{{rdv.skypeid}}</a>
                                </span>
                                <br>
                            </p>

                        </v-col>
                        <v-col class="text-left">
                            <v-btn v-if="rdv.assignedagentid == ''" color="primary" class="float-right" @click="acceptRdv(rdv)">J'accepte la mission</v-btn>
                            <v-btn v-if="rdv.assignedagentid == userId && rdv.customdata.statusappel == ''" color="primary" class="float-right" :to="{ name: 'ViewConnect', params: { id: rdv.id }}">Faire l'appel</v-btn>
                            <p v-if="rdv.assignedagentid == userId && rdv.customdata.statusappel != ''">
                                <strong>Status de l'appel :</strong> {{ rdv.customdata.statusappel }}<br>
                                <span v-if="rdv.customdata.budgetclient != ''"><strong>Budget du client :</strong>{{ rdv.customdata.budgetclient }}<br></span>
                                <span v-if="rdv.customdata.typeachatclient != ''"><strong>Type d'achat :</strong> {{ rdv.customdata.typeachatclient }}<br></span>
                                <span v-if="rdv.customdata.interetclient != ''"><strong>Niveau Intérêt du Client :</strong> {{ rdv.customdata.interetclient }}<br></span>
                                <span v-if="rdv.customdata.prochaineactionclient != ''"><strong>Prochaine action planifiée :</strong> {{ rdv.customdata.prochaineactionclient }}<br></span>
                                <span v-if="rdv.customdata.commentaireclient != ''"><strong>Commentaire :</strong> {{ rdv.customdata.commentaireclient }}<br></span>
                                <span v-if="rdv.customdata.statusappel == 'Effectué'"><strong>Intéressé par :</strong> <span v-for="model in rdv.customdata.modelsclient" v-bind:key="model.name"><span v-if="model.selection == true">{{model.name}}, </span></span></span>
                            </p>

                        </v-col>
                    </v-row>
                </div>
            </div>
        </v-container>
    </v-app>
</template>

<script>
    import NProgress from "nprogress"
    export default {
        name: "ListeNouvelleDemande",
        data () {
            return {
                snackbar: false,
                errorMsg: '',
                loading: false,
                rdvs: []
            }
        },
        methods: {
            getNewRdv(){
                NProgress.start()
                this.loading = true
                let params = {}
                console.log("On demande les nouveaux rdv")
                params.action = 'getNewRdv'
                this.axios
                    .post(this.$store.state.rootUrl+'apiSales.php',params,{timeout: 10000})
                    .then((data) => {
                        console.log(data)
                        if(data.error === true){
                            console.log("Erreur")
                            this.errorMsg = 'Oups. Nous ne parvenons pas a récupérer les derniers rendez-vous !'
                            this.snackbar = true
                            this.loading = false;
                            NProgress.done()
                            return false
                        }
                        let results = []

                        data.data.data.forEach((element) => {
                            element.calendarurl = this.$store.state.rootUrl+'apiSales.php?action=getCalendarLink&token='+this.$store.state.user.jwt+'&rdvid='+element.id
                            results.push(element)
                        })
                        this.rdvs = results
                        NProgress.done()
                    })
                    .catch( error => {
                        console.log(error);
                        this.errorMsg = 'Oups. Impossible de joindre le serveur ! Veuillez réessayer dans quelques instants'
                        this.snackbar = true
                        NProgress.done()
                    })
                this.loading = false
                NProgress.done()
            },
            acceptRdv(rdv){
                if(!confirm('Etes vous sur de vouloir prendre en charge le prospect '+rdv.name+'?')){
                    return false;
                }
                NProgress.start()
                this.loading = true
                var params = {}

                params.action = 'acceptRdv'
                params.id = rdv.id
                this.axios
                    .post(this.$store.state.rootUrl+'apiSales.php',params,{timeout: 10000})
                    .then((data) => {
                        if(data.error === true){
                            this.errorMsg = 'Impossible de changer le status du RDV. Veuillez réessayer dans quelques instants'
                            this.snackbar = true
                            NProgress.done()
                            return false
                        }
                        window.open(this.$store.state.rootUrl+'apiSales.php?action=getCalendarLink&token='+this.$store.state.user.jwt+'&rdvid='+params.id, '_blank');
                        location.reload()
                        NProgress.done()
                    })
                    .catch( () => {
                        this.errorMsg = 'Oups Erreur Serveur. Veuillez réessayer dans quelques instants'
                        this.snackbar = true
                        NProgress.done()
                    })
                this.loading = false
                NProgress.done()
            }
        },
        mounted () {
            this.getNewRdv()
        }
    }
</script>

<style scoped>

</style>
